<template>
  <div class="flex flex-col">
    <span
      class="text-[0.875rem] leading-[1.25rem]"
    >
      {{ upperLabel }}
    </span>
    <div class="p-2">
      <div class="h-[0.25rem] relative w-full bg-[#EEEEEE]">
        <div
          class="h-full ml-0 rounded-full"
          :style="{
            width: `${percentage}%`,
            backgroundColor: `${hexColor}`
          }"
        />
        <div
          class="absolute z-10 top-1/2 -translate-y-1/2 -translate-x-1/2 w-[1.25rem] h-[1.25rem] rounded-full flex items-center justify-center "
          :style="{
            left : `${percentage}%`,
            backgroundColor: `${hexColor}`,
            boxShadow: `0 0 0 0.625rem ${hexColor}1f`
          }"
        >
          <div class="relative">
            <div
              class="absolute bottom-[calc(100%+0.75rem)] -translate-x-1/2 flex items-center justify-center z-20"
            >
              <span class="relative flex items-center justify-center">
                <svg
                  width="28"
                  height="35"
                  viewBox="0 0 28 35"
                  :style="{color: `${hexColor}`}"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14 34.251L4.1005 24.2926C-1.36684 18.7928 -1.36684 9.87572 4.1005 4.37587C9.56784 -1.12399 18.4322 -1.12399 23.8995 4.37587C29.3668 9.87572 29.3668 18.7928 23.8995 24.2926L14 34.251Z"
                    fill="currentColor"
                  />
                </svg>
                <span class="absolute left-1/2 -translate-x-1/2 top-[7px] z-30 text-white font-medium text-[0.75rem] leading-[0.875rem]">
                  {{ percentage }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex w-full justify-between">
      <span
        class="text-[0.875rem] leading-[1.25rem]"
      >
        {{ zeroLabel }}
      </span>
      <span
        class="text-[0.875rem] leading-[1.25rem]"
      >
        {{ hundredLabel }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    upperLabel: {
      type: String,
      default: ''
    },
    zeroLabel: {
      type: String,
      default: ''
    },
    hundredLabel: {
      type: String,
      default: ''
    },
    hexColor: {
      type: String,
      default: ''
    },
    percentage: {
      type: Number,
      default: 0
    }
  }
}
</script>